import Vue from 'vue'
import Router from 'vue-router'
import util from '@/v2/utils/util'
import auth from '@/v2/utils/auth'
import { baseApi } from '@/v2/utils/api'

/**
 * 考试相关
 */

import SingleExamRouter from './exam/single' // 单科考试
import SingleExamReportRouter from '@/v3/modules/report/router/single' // 单科考试报告
import SingleExamScreenReportRouter from '@/v3/modules/report/router/singleScreen' // 单科考试报告投影

import MultipleExamRouter from './exam/multiple' // 多科考试
import MultipleExamReportRouter from '@/v3/modules/report/router/multiple' // 多科考试报告

import MarkingExamRouter from './exam/marking' // 网络阅卷

import Gaokao from '@/v3/modules/report/router/gaokao' // 新高考

import SystemRouter from '@/v3/modules/datamanage/router/system' // 系统管理

import ToolRouter from './tool' // 工具栏

import { ArchivesRouter, bigDataRouter, bigDataDetailRouter } from '@/v3/modules/datamanage/router/study' // 大数据中心

import CardRouter from '@/v3/modules/card/router/card' // 题库

// 系统帮助
import NewHomeHelp from './new-home-help'
// 系统消息
import NewHomeMessage from './new-home-message'
// 新主页
import NewHome from './new-home'

import recordQuestion from './recordQuestion'
import answer from './exam/answer'

import v2 from '@/v2/router/index' // 新版页面

import CardManage from '@/v3/modules/card/router/index'
import ErrorBookManage from '@/v3/modules/errorbook/router/index'
import ZujuanRouter from '@/v3/modules/card/router/zujuan'

const oAuth = r => require(["@/v3/modules/login/views/oauth"], r);
const SsoLogin = r => require(["@/v3/modules/login/views/sso"], r);
const PrintTranscriptMistakes = r => require(["@/pages/print/transcriptMistakes"], r);
const TemDownload = r => require(["@/pages/tem/download"], r);
const PaperMark = r => require(["@/pages/tem/paper-mark"], r);

const Layout = r => require(['@/pages/PageLayout'], r)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
} // 制卡管理

Vue.use(Router) // 组卷内嵌页面
const router = new Router({
  linkActiveClass: 'actived',
  linkExactActiveClass: 'actived',
  hashbang: false,
  base: __dirname,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      redirect: '/login',
      name: ''
    },
    {
      path: '/login',
      redirect: '/sso-login'
    },
    {
      path: '/sso-login',
      component: SsoLogin, // sso登录
      name: 'SsoLogin',
      meta: {
        title: '登录'
      }
    },
    {
      path: '/oauth',
      component: oAuth, // 授权登录页
      name: 'oauth'
    },

    // 系统帮助
    NewHomeHelp,
    // 系统消息
    NewHomeMessage,
    // 新主页
    NewHome,

    ArchivesRouter, // 档案管理
    bigDataRouter, // 大数据
    bigDataDetailRouter, // 大数据分析

    ToolRouter, // 工具箱

    SystemRouter, // 系统管理

    ...CardRouter,

    SingleExamScreenReportRouter, // 单科校级报告投影模式
    answer,
    {
      path: '/exam',
      component: Layout,
      meta: { auth: 'Exam', checkAuth: true },
      children: [
        ...SingleExamRouter, // 单科考试
        ...SingleExamReportRouter, // 单科报告
        ...MultipleExamRouter, // 多科考试
        MultipleExamReportRouter, // 多科考试报告
        ...MarkingExamRouter, // 网络阅卷
        ...Gaokao, // 新高考
      ]
    },

    {
      path: '/print/:examId/:classId/:studentId/transcriptMistakes',
      meta: { auth: 'Home' },
      component: PrintTranscriptMistakes
    },
    ...ZujuanRouter,
    {
      path: '/tem/download',
      name: 'TemDownload',
      component: TemDownload
    },
    {
      path: '/paper/mark',
      name: 'PaperMark',
      component: PaperMark
    },
    // recordQuestion.operation,
    ...recordQuestion.paper,
    v2,
    {
      path: '/share/answer/:id',
      name: 'ShareAnswer',
      component: r => require(['@/v2/views/share/shareAnswer'], r)
    },
    {
      path: '/v2',
      component: r => require(['@/v2/views/exam/answer/layout'], r),
      children: [
        {
          path: '/v2/exam/student-answer/:id',
          name: 'StudentAnswerNew',
          component: r => require(['@/v2/views/exam/answer/student-answer'], r)
        },
        {
          path: '/v2/exam/scan-batch/:id',
          name: 'ScanBatchNew',
          component: r => require(['@/v2/views/exam/answer/scan-batch'], r)
        }
      ]
    },
    CardManage,
    ErrorBookManage,
    {
      path: '/no-auth',
      component: r => require(['@/v3/modules/noAuth/views/no-auth'], r),
      name: 'NoAuth',
      meta: {
        title: '无权限'
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (YJ_SCHOOL_STORAGE.getItem('token')) {
    if (to.meta.checkAuth || to.meta.auth) {
      let result = false
      if (to.meta.moreAuths && to.meta.moreAuths.length > 0) {
        result = util.isMoreAuth(to.meta.auth, to.meta.moreAuths, to.params.id)
      } else {
        result = util.isAuth(to.meta.auth)
      }

      if (result) {
        if (to.meta.title) {
          document.title = 'e卷通-考试-' + to.meta.title
        }
        await xepRouterAction(to, from, next)
      } else {
        const query = { message: encodeURIComponent('您暂无该页面权限，如有需要请联系'), fromPath: to.path }
        if (YJ_SCHOOL_STORAGE.getItem('userInfo')) {
          const userInfo = JSON.parse(YJ_SCHOOL_STORAGE.getItem('userInfo'))
          query.message = encodeURIComponent('您暂无该页面权限，如有需要请联系“' + userInfo.schoolName + '”的管理员')
        }
        next({ path: '/no-auth', query })
      }
    } else {
      await xepRouterAction(to, from, next)
    }
  } else if (to.name !== 'SsoLogin' && to.name !== 'oauth' && to.name !== 'ShareAnswer') {
    YJ_SCHOOL_STORAGE.setItem('url_before_login', location.href)
    next({ path: '/sso-login' })
  } else {
    await xepRouterAction(to, from, next)
  }
})

async function xepRouterAction (to, from, next) {
  baseApi.checkBuildVersion()
  if (to.name !== 'SsoLogin' && to.name !== 'oauth') {
    await auth.tryUpdateAuths()
  }
  // xep路由跳转盘末端
  if (!!from.query.xep_flag && !to.query.xep_flag) {
    // xep下的页面，增加相关前缀
    const newRoute = {
      ...to
    }
    newRoute.query.xep_flag = from.query.xep_flag
    next(false)
    router.push(newRoute)
  } else {
    next()
  }
}

router.afterEach((to, from) => {
  if (window.addIOClick) {
    window.addIOClick()
  }
})

export default router
